import React from "react";
import { Package, TrendingUp } from "lucide-react";
import { Link } from "react-router-dom";

const ProductPerformanceWidget = ({ productData }) => {
  if (!productData || !productData.bestSellers) return null;

  const formatCurrency = (value) => {
    return `₹${parseFloat(value || 0).toFixed(2)}`;
  };

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-indigo-500 rounded-md flex items-center justify-center">
            <TrendingUp className="w-6 h-6 text-white" />
          </div>
          <div className="ml-4">
            <h3 className="text-sm font-medium text-gray-500">Top Products</h3>
            <p className="text-xs text-gray-400">Best sellers this period</p>
          </div>
        </div>
      </div>

      {productData.bestSellers && productData.bestSellers.length > 0 ? (
        <div className="space-y-3">
          {productData.bestSellers.slice(0, 5).map((product, index) => (
            <div
              key={product.productId || index}
              className="flex items-center justify-between p-3 bg-gray-50 rounded-md"
            >
              <div className="flex items-center flex-1 min-w-0">
                <div className="flex-shrink-0 w-8 h-8 bg-indigo-100 rounded-md flex items-center justify-center">
                  <span className="text-xs font-semibold text-indigo-600">
                    #{index + 1}
                  </span>
                </div>
                <div className="ml-3 flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {product.name || "Unknown Product"}
                  </p>
                  <p className="text-xs text-gray-500">
                    {product.quantity} units sold
                  </p>
                </div>
              </div>
              <div className="ml-2 text-right">
                <p className="text-sm font-semibold text-gray-900">
                  {formatCurrency(product.revenue)}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          <Package className="w-12 h-12 mx-auto mb-2 text-gray-400" />
          <p className="text-sm">No product data available</p>
        </div>
      )}

      <Link
        to="/admin/sales"
        className="block text-center text-sm text-primary-600 hover:text-primary-700 font-medium mt-4"
      >
        View Full Analytics →
      </Link>
    </div>
  );
};

export default ProductPerformanceWidget;

